import { Overrides } from '@material-ui/core/styles/overrides';
import pallete from '../palette';

const MuiButton: Overrides['MuiButton'] = {
  sizeSmall: {
    width: '148px',
  },
  sizeLarge: {
    width: '280px',
  },
  root: {
    width: '206px',
    textTransform: 'none',
  },
  outlined: {
    border: `1px solid ${pallete.primary.dark}`,
    color: pallete.primary.dark,
    '&:hover': {
      backgroundColor: pallete.primary.light,
      border: `1px solid ${pallete.primary.light}`,
      color: pallete.common.white,
    },
  },
  contained: {
    backgroundColor: pallete.primary.dark,
    color: pallete.common?.white,
    '&:hover': {
      backgroundColor: pallete.primary.light,
    },
  },
};

export default MuiButton;
